import { FormInstance } from "antd";
import { useTranslation } from "react-i18next";

export function useValidateChoosingAtLeastOneAlertType(naturalForestAlerts: boolean, observationAlerts: boolean, form: FormInstance<any>) {
    const { t } = useTranslation("emailAlerts");

    return (rule: any, value: any, callback: (error?: string) => void) => {
        if (naturalForestAlerts === false &&
            observationAlerts === false) {

            return Promise.reject(t("valitseHälytystyyppi"));
        }
        else if (observationAlerts !== naturalForestAlerts) {
            if (rule.field === "naturalForests" && form.getFieldError(["observations"]).length > 0) {
                form.validateFields(["observations"]);
            }
            else if (rule.field === "observations" && form.getFieldError(["naturalForests"]).length > 0) {
                form.validateFields(["naturalForests"]);
            }
        }

        return Promise.resolve();
    };
}
